import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { emptyArray } from 'ui-components/default-props/empty';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { getShipperHQOrderDetails } from './api';
import { messages } from './messages';
import { Overview } from './overview';
import { ShipmentDetails } from './shipment-details';
import style from './style.module.less';

const ErrorPlaceholder = () => (
  <div className={style.error}>
    <FormattedMessage {...messages.onErrorMessage} />
  </div>
);

export const ShipperHQDetailsModal = ({ storeGuid, orderNumber }) => {
  const [details, setDetails] = useAsyncSafeState();
  const [isLoading, setIsLoading] = useAsyncSafeState(true);
  const [hasError, setHasError] = useAsyncSafeState(false);

  useEffect(() => {
    getShipperHQOrderDetails(storeGuid, orderNumber)
      .then(setDetails)
      .catch(() => setHasError(true))
      .finally(() => setIsLoading(false));
  }, [storeGuid, orderNumber, setDetails, setIsLoading, setHasError]);

  const { orderDetail = {}, shipments = emptyArray } = details ?? {};

  return (
    <Modal className={style.modal}>
      <ModalHeader>
        <FormattedMessage {...messages.shipperHQModalHeader} />
      </ModalHeader>
      <ModalBody className={style.body}>
        {isLoading && <LoadingIndicator className={style['loading-indicator']} theme='grey' />}
        {!isLoading && hasError && <ErrorPlaceholder />}
        {!isLoading && !hasError && details && (
          <>
            <Overview orderNumber={orderNumber} overview={orderDetail} />
            {shipments.map((shipment) => (
              <ShipmentDetails key={shipment.id} shipment={shipment} />
            ))}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

ShipperHQDetailsModal.propTypes = {
  storeGuid: PropTypes.string.isRequired,
  orderNumber: PropTypes.string.isRequired,
};
